
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BackupServerDto, BackupServerRepositoryInterface } from "@/services/Backup/interfaces";
import { AxiosError } from "axios";

@Component({
  inject: ['backupServerRepository'],
})
export default class BackupServerPicker extends Vue {
  private backupServerRepository!: BackupServerRepositoryInterface;

  public backupServerSearchLoading = false;

  public backupServers: BackupServerDto[] = [];

  @Prop({ default: 0, required: true, type: Number }) public value!: number;

  private _backupServerSearch = '';

  public get backupServerSearch(): string {
    return this._backupServerSearch;
  }

  public set backupServerSearch(val: string) {
    this._backupServerSearch = val;

    this.fetchBackupServers(val);
  }

  get backupServerId(): number {
    return this.value;
  }

  set backupServerId(value: number) {
    this.$emit('input', value);
  }

  public async created() {
    // await this.fetchBackupServers("");
    const result = await this.backupServerRepository.searchBackupServers({
      page: 1,
      pageSize: 10,
    });

    this.backupServers = result?.data ?? [];
  }

  public async fetchBackupServers(query: string): Promise<void> {
    try {
      this.backupServerSearchLoading = true;
      const result = await this.backupServerRepository.searchBackupServers({
        page: 1,
        pageSize: 10,
        search: query,
      });

      this.backupServers = result?.data ?? [];

    } catch (err) {
      this.onError(err);
    } finally {
      this.backupServerSearchLoading = false;
    }
  }

  private onError(err: unknown): void {
    const asAxiosError = err as AxiosError;
    if (asAxiosError.isAxiosError) {
      this.$errorDialog.show(asAxiosError.response?.data?.message ?? 'An axios error occurred');
    } else if (err instanceof Error) {
      this.$errorDialog.show(err.message);
    } else {
      this.$errorDialog.show('An unknown error occurred');
    }
  }
}

